import type { ImageProps } from 'next/image';

import { Link } from '@natu/next-link';
import { cn } from '@natu/utils/cn';
import type { PredefinedGAEvents } from '@natu/utils/events';

import {
  getAssetFromStoryblok,
  getLinkPropsFromStoryblok,
  resolveStoryblokStyles,
  sbEditable,
  type SBProps,
  type Spacing,
  type StoryblokAsset,
  type StoryblokLink,
} from '../../../../utils';
import { CardContent } from './CardContent';
import { LinkWithEvent } from './LinkWithEvent';

interface SBAboutServiceCardProps {
  image?: StoryblokAsset;
  title?: string;
  content?: string;
  link?: StoryblokLink;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  event?: PredefinedGAEvents;
}

export const SBAboutServiceCard = ({ blok }: SBProps<SBAboutServiceCardProps>) => {
  const {
    content,
    image,
    link,
    title,
    mbDesktop,
    mbMobile,
    mbTablet,
    mtDesktop,
    mtMobile,
    mtTablet,
    event,
  } = blok;

  const resolvedImage = getAssetFromStoryblok(image);
  const resolvedLink = getLinkPropsFromStoryblok(link);

  const className = cn(
    'group flex flex-col',
    resolveStoryblokStyles({
      mt: mtMobile,
      mtTablet,
      mtDesktop,
      mb: mbMobile,
      mbTablet,
      mbDesktop,
    }),
  );

  if (!resolvedLink) return null;

  if (event)
    return (
      <LinkWithEvent className={className} link={resolvedLink} event={event} {...sbEditable(blok)}>
        <CardContent
          image={resolvedImage as ImageProps}
          title={title}
          content={content}
          buttonLabel="Check"
        />
      </LinkWithEvent>
    );

  return (
    <Link className={className} {...resolvedLink} {...sbEditable(blok)}>
      <CardContent
        image={resolvedImage as ImageProps}
        title={title}
        content={content}
        buttonLabel="Check"
      />
    </Link>
  );
};
